import React, { Component } from "react";
import { Link } from "react-router-dom";
import { computed } from "mobx";
import MainBody from "./Components/Body";
import { NavLink } from "react-router-dom";

import { Helmet } from "react-helmet";
import { TiThLargeOutline, TiCodeOutline, TiPen } from "react-icons/ti";
import { FiLogOut } from "react-icons/fi";
import { CiMoneyBill } from "react-icons/ci";
import { observer, inject } from "mobx-react";
@inject("store")
@observer
class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
      active: "",
    };
  }
  @computed get permissions() {
    return this.props.store.tools.filter((tool) =>
      tool.permissions.some((r) =>
        this.props.store.profile.permissions.includes(r)
      )
    );
  }
  handleClick = (id) => {
    console.log(id);
  };
  @computed get Marketing() {
    return this.permissions.filter((tool) => tool.category === "Meal Planning");
  }



  render() {
    return (
      <>
        <Helmet>
          <title>{`Dashboard - MealPalAI`}</title>
        </Helmet>
        <div class="w-full flex flex-col md:flex-row overflow-hidden h-screen-2 md:overflow-hidden ">
          <aside
            class="w-full hidden md:flex flex main_aside  md:w-1/5 h-screen-2 bg-dark-4 md:flex items-stretch flex-col md:overflow-hidden md:flex"
            aria-label="Sidebar"
          >
            <ul className="px-6 mt-0 block flex flex-col">

              <li
                onClick={() => this.setState({active:'Meal Planning'})}
                className={`px-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 mb-2 text-grey-600 flex items-center text-c-gray hover:text-white cursor-pointer ${this.state.active ==='Marketing'? 'active' : 'inactive'}`}
              >
                <a href="#MealPlanning" className="flex">
                  <TiCodeOutline size="24" />{" "}
                  <span className="pl-3 font-size-20">Meal Planning</span>
                </a>
              </li>
            </ul>
            <div className=" relative md:self-start mb-3 mx-6  w-full divider-center    divide-y divide-solid divide-gray-100 divide-opacity-30 md:mt-auto">
                {" "}
                <div></div>
                <div></div>
              </div>
            <NavLink
            onClick={() => this.setState({active:'pricing'})}
              to="/my-profile/pricing" 
              className="relative  w-full md:w-80 mb-2 px-6 mx-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 text-white flex items-center hover:text-white cursor-pointer"
            >
              <CiMoneyBill size="24" />
              <span className="pl-3 font-size-20">Manage Plan</span>
            </NavLink>

            <div
              className="relative  w-full md:w-80 px-6 mx-6 py-4 focus:bg-light-gray hover:bg-black border-radius-12 text-white flex items-center hover:text-white cursor-pointer"
              onClick={this.props.store.handleLogout}
            >
              <FiLogOut size="24" />
              <span className="pl-3 font-size-20">Log out</span>
            </div>
          </aside>
          <div class="w-full md:w-4/5    bg-dark-6 h-screen-2 md:overflow-y-scroll">
            <MainBody className="py-0 md:px-9 md:pb-4 lg:pb-6 ">

              
              {this.Marketing.length ? (
                <>
                  <div id="Marketing">
                    <Title title="Meal Planning" />
                    <Grid>
                      {this.Marketing.map((tool, index) => (
                        <Tool
                          key={index}
                          group={tool.category}
                          title={tool.title}
                          to={tool.to}
                          Icon={tool.Icon}
                          desc={tool.desc}
                          fromColor={tool.fromColor}
                          toColor={tool.toColor}
                        />
                      ))}
                    </Grid>
                    <Divider />
                  </div>
                </>
              ) : null}

              
            </MainBody>
          </div>
        </div>
      </>
    );
  }
}

export const Divider = () => (
  <div className="divide-y divide-solid divide-gray-100 py-4 md:py-6 divide-opacity-30  ">
    {" "}
    <div></div>
    <div></div>
  </div>
);

export const Title = ({ title }) => (
  <h2 className="text-center sm:mb-6 tools_title md:text-left text-2xl sm:text-2xl md:text-1xl text-bold text-white mb-1 mt-1 md:mb-3">
    {title}
  </h2>
);

export const Grid = ({ children }) => (
  <div className="grid grid-cols-2 gap-2 md:gap-8 lg:grid-cols-4 xl:grid-cols-5 mb-4">
    {children}
  </div>
);

export const Tool = ({ Icon, title, desc, to, group, fromColor, toColor }) => (
  <Link to={to || "/"} className="flex relative items-center dashboard_box">
    <div
      className={`bg-tools flex-1 h-full rounded-xl transition hover:shadow-md overflow-hidden md:max-w-1lg text-gray-300 cursor-pointer border border-gray-300 md:flex  relative transform hover:scale-105  hover:text-white`}
    >
      <div className="p-4 flex items-center text-center flex-col">
        <div className="flex justify-center items-center text-center bg-yellow-200 bg-opacity-30     rounded-full w-16 h-16 mb-4">
          <Icon size="24" color="#ffff" />
        </div>

        {/* <div className={`uppercase tracking-wide text-sm text-center text-${fromColor ? fromColor : "green-500"} font-semibold leading-none`}>{group || "New"}</div> */}
        <div
          href="#"
          className="block font-size-20 mb-2 leading-tight font-medium text-c-yellow leading-none text-center"
         
        >
          {title}
        </div>
        <p className="mt-1 pr-1 text-sm text-center text-white text-opacity-50  font-16">
          {desc}{" "}
        </p>
      </div>
    </div>
  </Link>
);

export default Body;